import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { database } from "../firebase.config";

export function useLiveStatus() {
  const [isLiveActive, setIsLiveActive] = useState(false);

  useEffect(() => {
    const liveStatusRef = ref(database, "liveStatus");

    const unsubscribe = onValue(liveStatusRef, (snapshot) => {
      const value = snapshot.val();

      const active = value === true;
      setIsLiveActive(active);
    }, (error) => {
      console.error("onValue error:", error);
      setIsLiveActive(false);
    });

    return () => unsubscribe();
  }, []);

  return isLiveActive;
}
